module.exports = __webpack_public_path__ + "20250721160708/img/setting.e17dc2ab.png";